import {
  BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer,
} from 'recharts';

const COLORS = ['#ef3361', '#ffa851', '#0c99c1', '#0c99c1', '#00b7a8'];

export default function CurrMarksChart({ data, is_complete }) {
  const title = is_complete
    ? 'Ukupna prosječna ocjena: ' + data.avg
    : 'Tekuća prosječna ocjena: ' + data.avg;

  return (
    <div style={{ width: '100%', height: 300 }}>
      <div style={{ textAlign: 'center' }}>{title}</div>
      <ResponsiveContainer>
        <BarChart
          width={350} height={200} data={data.data}
          margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="ocjena" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="ukupan broj" fill="#1976d2" label={{ position: 'top' }}>
            {data.data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
